import { render, staticRenderFns } from "./CourierHubUserGroupSelector.vue?vue&type=template&id=f07f2960&"
import script from "./CourierHubUserGroupSelector.vue?vue&type=script&lang=js&"
export * from "./CourierHubUserGroupSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports